// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, onMessage, getToken } from "firebase/messaging";
import { config } from "../../config";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// const firebaseConfig = {
//   apiKey: "...",
//   authDomain: "...",
//   projectId: "...",
//   storageBucket: "...",
//   messagingSenderId: "...",
//   appId: "...",
//   measurementId: "..."
// };

const firebaseConfig = config.push_notification.config
const apiKey = config.push_notification.apiKey;

export class ForegroundNotificationManager {
  static VISIBILITY_KEY = "firebase:visibility";
  static HAS_FOCUS_KEY = "firebase:has_focus";
  static registration = null;

  static _filter = {
    tags: [],
    keywords: []
  }
  // Set to FALSE if you want to manage local notification inside windows 
  // then no local notification will be generated
  enableLocalNotification = true;

  // Local notification triggered only if _visibility = 'hidden' and _hasFocus = false in all application tabs
  // _visibility = true;
  // _hasFocus = 'visible';
  
  _checkIfMainTabCallback = () => { return true };
  static _onNewTokenCallback = null;

  constructor(config) {
    this._initForegroundListener();
    this._initServiceWorker();
    ForegroundNotificationManager._updateLocalNotificationFlag('visible', true);    
    window.addEventListener('focus', function logData() {
      ForegroundNotificationManager._updateLocalNotificationFlag(document.visibilityState, document.hasFocus());
    }.bind(this));

    window.addEventListener('blur', function logData() {
      ForegroundNotificationManager._updateLocalNotificationFlag(document.visibilityState, document.hasFocus());
    }.bind(this));
  }

  _initServiceWorker() {
    if ('serviceWorker' in navigator) {
      if(!ForegroundNotificationManager.registration) {
        // console.log('firebaseConfig', firebaseConfig)
        
        let cfg = JSON.stringify(firebaseConfig)
        navigator.serviceWorker.register('firebase-notification-sw.js?config='+cfg)
            .then(function (registration) {
                ForegroundNotificationManager.registration = registration
                // registration worked
                console.log('Registration succeeded. Scope is ' + registration.scope);
                ForegroundNotificationManager._getNotificationToken(ForegroundNotificationManager._onNewTokenCallback)
            }).catch(function (error) {
                // registration failed
                console.log('Registration failed with ' + error);
            });
      } else {
        console.error("ServiceWorker not valid")
      }
      
      navigator.serviceWorker.addEventListener('message', function handler(event) {
        // console.log('[CLIENT] Received a message from service worker: ', event);
  
        if(event.data.type !== undefined) {
          ForegroundNotificationManager._triggerEvent(event.data.type, event.data.message, event.data.focus);
        }
      });
    }
  }

  _initForegroundListener() {
    // Initialize Firebase
    const firebaseApp = initializeApp(firebaseConfig);

    const messaging = getMessaging(firebaseApp);

    onMessage(messaging, (payload) => {
      const data = {
        id: parseInt(payload.data.id),
        silent: (payload.data.silent === "true") ? true : false,
        title: payload.data.title,
        body: payload.data.body,
        tag: payload.data.tag,
        keywords: payload.data.keywords ? payload.data.keywords.split("|") : [],
        count_with_tag: parseInt(payload.data.count_with_tag),
        payload: (() => { 
          delete payload.data.id;
          delete payload.data.silent; 
          delete payload.data.title; 
          delete payload.data.body;
          delete payload.data.tag;
          delete payload.data.count_with_tag;

          return payload.data;
        })(),
        read_at: null,
      }
      console.log('onMessage', payload, data)

      if(ForegroundNotificationManager._isValidNotification(data)) {
        ForegroundNotificationManager._triggerEvent("onForegroundMessage", data, false);
  
        const notificationTitle = data.title;
        const notificationOptions = {
          body: data.body,
          icon: '/favicon.png'
        };
  
        if( (!data.silent) && this._isLocalNotificationEnabled() && this._checkIfMainTabCallback()) {
          const localNotification = new Notification(notificationTitle, notificationOptions);
  
          localNotification.onclick = function(event) {
            event.preventDefault(); // prevent the browser from focusing the Notification's tab
            ForegroundNotificationManager._triggerEvent("onForegroundNotificationClick", data, false);
            localNotification.close();
            window.focus(); //Firefox default disable windows.focus
          }
        }
      }

    });
  }



  static _isValidNotification(payload) {
    // console.log('FRG - _isValidNotification', payload, ForegroundNotificationManager._filter)
    let validTag = true
    let validKeywords = true

    if(ForegroundNotificationManager._filter.tags.length > 0 && payload.tag) {
      validTag = ForegroundNotificationManager._filter.tags.includes(payload.tag);
    }

    if(ForegroundNotificationManager._filter.keywords.length > 0 || payload.keywords.length > 0) {
      validKeywords = ForegroundNotificationManager._filter.keywords.some( (ai) => payload.keywords.includes(ai) );
    }

    return (validTag && validKeywords)
  }

  static _updateLocalNotificationFlag(visibility, hasFocus) {
    // localStorage.removeItem(ForegroundNotificationManager.VISIBILITY_KEY);
    // localStorage.setItem(ForegroundNotificationManager.VISIBILITY_KEY, visibility);
    localStorage.removeItem(ForegroundNotificationManager.HAS_FOCUS_KEY);
    localStorage.setItem(ForegroundNotificationManager.HAS_FOCUS_KEY, hasFocus);
  }

  _isLocalNotificationEnabled() {
    const hasFocus = localStorage.getItem(ForegroundNotificationManager.HAS_FOCUS_KEY);
    const notify = (hasFocus === 'false');

    return notify;
  }

  static _triggerEvent(type, message, focus) {
    const event = new CustomEvent(
      "notification::"+type, 
      {
        detail: { 
          data: message,
          focus: focus
        }
      }
    );
    window.dispatchEvent(event);
  }

  static _permissionAlert() {
    alert('Enable push notification in your browser or application will not work properly!')
  }

  static _getNotificationToken(onNewTokenCallback, mandatory = true) {
    if(config.push_notification.enabled && ForegroundNotificationManager.registration) {
      const messaging = getMessaging();

      getToken(messaging, { vapidKey: apiKey, serviceWorkerRegistration: ForegroundNotificationManager.registration }).then((currentToken) => {
        if (currentToken) {
          // Send the token to your server and update the UI if necessary
          onNewTokenCallback(currentToken);
        } else {
          // Show permission request UI
          console.log('No registration token available. Request permission to generate one.');
          
          if(mandatory) {
            Notification.requestPermission().then(function(permission) { ForegroundNotificationManager._permissionAlert(); });
          }
        }
      }).catch((err) => {
        if(mandatory) {
          console.warn('An error occurred while retrieving token: ', err);
          Notification.requestPermission().then(function(permission) { ForegroundNotificationManager._permissionAlert(); });
        }
        // ...
        // let requestPermission = window.confirm('No registration token available. Request permission to generate one.')
        // if(requestPermission) {
        //   Notification.requestPermission().then(function(permission) { console.log('permiss', permission)});
        // }
      });
    }
  }

  /**
   * Send message from page to service
   * @param {*} payload 
   */
  static postMessage(type, payload) {
    if ('serviceWorker' in navigator) {
      if(navigator.serviceWorker.controller) {
        navigator
          .serviceWorker
          .controller
          .postMessage({
            type: type,
            payload: payload
          })
      } else {
        console.warn("Can't send message to serviceWorker")
      }
    } else {
      console.warn("Can't send message to serviceWorker")
    }
  }

  /**
   * Init notification setting firebase foreground notification behaviour
   * 
   * @param {function} onNewTokenCallback - the callback delegate to manage notification token
   * @param {function} checkIfMainTabCallback - the callaback delagate to define who is the notification handler tab
   */
  async initNotification(onNewTokenCallback, checkIfMainTabCallback = null, mandatory = false) {
    if(checkIfMainTabCallback !== null) {
      this._checkIfMainTabCallback = checkIfMainTabCallback;
    }

    ForegroundNotificationManager._onNewTokenCallback = onNewTokenCallback
    
  }  

  static addTagFilter(tag) {
    ForegroundNotificationManager._filter.tags.push(tag)
    ForegroundNotificationManager.postMessage("notification:filter", ForegroundNotificationManager._filter)
  }

  static removeTagFilter(tag) {
    var index = ForegroundNotificationManager._filter.tags.indexOf(tag);
    if (index !== -1) {
      ForegroundNotificationManager._filter.tags.splice(index);
    }
    ForegroundNotificationManager.postMessage("notification:filter", ForegroundNotificationManager._filter)
  }

  static addKeywordFilter(keyword) {
    console.log('Firebase - addKeywordFilter', keyword)
    ForegroundNotificationManager._filter.keywords.push(keyword)
    ForegroundNotificationManager.postMessage("notification:filter", ForegroundNotificationManager._filter)
  }

  static removeKeywordFilter(keyword) {
    var index = ForegroundNotificationManager._filter.keywords.indexOf(keyword);
    if (index !== -1) {
      ForegroundNotificationManager._filter.keywords.splice(index);
    }
    ForegroundNotificationManager.postMessage("notification:filter", ForegroundNotificationManager._filter)
  }
}